/* Riepilogo completo su mobile: la card .summary diventa un bottom sheet
   apribile dalla barra sticky. Nessun clone del DOM → tutti i binding di app.js restano validi. */
(function(){
  if(!document.body.classList.contains('page-config')) return;
  var sum = document.querySelector('#config .summary');
  var msum = document.getElementById('msum');
  if(!sum || !msum) return;

  /* trigger nella barra sticky */
  var info = msum.querySelector('.msum-info');
  var trigger = document.createElement('button');
  trigger.type = 'button'; trigger.className = 'msum-more';
  trigger.setAttribute('aria-label','Vedi riepilogo completo');
  trigger.setAttribute('aria-expanded','false');
  trigger.innerHTML = '<span class="msr">expand_less</span>';
  msum.insertBefore(trigger, msum.querySelector('.msum-btn'));

  /* backdrop + testa del sheet */
  var bd = document.createElement('div');
  bd.className = 'sum-sheet-bd'; bd.hidden = true;
  document.body.appendChild(bd);

  var head = document.createElement('div');
  head.className = 'sum-sheet-head';
  head.innerHTML = '<span class="sum-sheet-grab"></span><button type="button" class="sum-sheet-x" aria-label="Chiudi riepilogo"><span class="msr">close</span></button>';
  sum.insertBefore(head, sum.firstChild);

  function open(){
    bd.hidden = false;
    document.body.classList.add('sum-open');
    trigger.setAttribute('aria-expanded','true');
    sum.scrollTop = 0;
  }
  function close(){
    document.body.classList.remove('sum-open');
    trigger.setAttribute('aria-expanded','false');
    setTimeout(function(){ if(!document.body.classList.contains('sum-open')) bd.hidden = true; }, 300);
  }
  function toggle(){ document.body.classList.contains('sum-open') ? close() : open(); }

  trigger.addEventListener('click', toggle);
  if(info) info.addEventListener('click', toggle);
  bd.addEventListener('click', close);
  head.querySelector('.sum-sheet-x').addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  /* chiudendo con l'azione principale del sheet si torna al configuratore */
  sum.querySelectorAll('.btn-primary, .btn-cta').forEach(function(b){ b.addEventListener('click', close); });
})();
